{
  "SEARCH": {
    "TABS": {
      "ALL": "All results",
      "CONTACTS": "Kontakty",
      "CONVERSATIONS": "Rozhovory",
      "MESSAGES": "Messages",
      "ARTICLES": "Articles"
    },
    "SECTION": {
      "CONTACTS": "Kontakty",
      "CONVERSATIONS": "Rozhovory",
      "MESSAGES": "Messages",
      "ARTICLES": "Articles"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Searching",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/to focus",
    "INPUT_PLACEHOLDER": "Type 3 or more characters to search",
    "RECENT_SEARCHES": "Recent searches",
    "CLEAR_ALL": "Clear all",
    "MOST_RECENT": "Most recent",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Read more",
    "READ_LESS": "Read less",
    "WROTE": "wrote:",
    "FROM": "From",
    "EMAIL": "Email",
    "EMAIL_SUBJECT": "Predmet",
    "PRIVATE": "Private note",
    "TRANSCRIPT": "Transcript",
    "CREATED_AT": "created {time}",
    "UPDATED_AT": "updated {time}",
    "SORT_BY": {
      "RELEVANCE": "Relevance"
    },
    "DATE_RANGE": {
      "LAST_7_DAYS": "Posledných 7 dní",
      "LAST_30_DAYS": "Posledných 30 dní",
      "LAST_60_DAYS": "Posledných 60 dní",
      "LAST_90_DAYS": "Posledných 90 dní",
      "CUSTOM_RANGE": "Custom range:",
      "CREATED_BETWEEN": "Created between",
      "AND": "and",
      "APPLY": "Použiť",
      "BEFORE_DATE": "Before {date}",
      "AFTER_DATE": "After {date}",
      "TIME_RANGE": "Filter by time",
      "CLEAR_FILTER": "Clear filter"
    },
    "FILTERS": {
      "FILTER_MESSAGE": "Filter messages by:",
      "FROM": "Sender",
      "IN": "Schránka",
      "AGENTS": "Agenti",
      "CONTACTS": "Kontakty",
      "INBOXES": "Inboxes",
      "NO_AGENTS": "Žiadni agenti neboli nájdení",
      "NO_CONTACTS": "Start by searching to see results",
      "NO_INBOXES": "No inboxes found"
    }
  }
}
